import { configPromise } from "../../config/configMiddleware";
import { getWith, updateWith } from "../axios";

export async function GetAllNotifications(type: 'notification' | 'message', pageNumber: number, pageSize: number): Promise<any> {
    try {
        const config = await configPromise;
        const url = `${config.REACT_APP_API_URL}v2/notifications-v2/?type=${type}&page=${pageNumber}&size=${pageSize}`;
        return (await getWith<any[]>(url)) as any;
    } catch (ex: any) {
        throw ex.response.data;
    }
}

export async function markNotificationAsSeen(
  id: string
): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v2/notifications-v2/${id}`;
    return (await updateWith<any, any>(url, {seen: true})) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}